// TODO: This file is becoming a mess of Promises (Promise hell?) need to simplify it at some point
import { Backbone } from "extensions/backbone";
import Radio from "backbone.radio";
import { toast } from "extensions/toast";
import { ToastWithActions } from "common/components/toastActions/toastActions";

import { v4 as uuid } from "uuid";
import {
    captureException,
    setUserContext,
    setTagsContext,
    captureMessage
} from "extensions/sentry";

import { store } from "common/store";
import { emitter } from "common/emitter";
import { MerchantModel } from "common/merchant";
import { showError } from "common/components/error";

import { retry } from "common/helpers/retry";
import { users, user } from "common/config/api";

import {
    UserIsNotAssigned,
    UnableFetchUserData,
    NoViewPrivileges,
    NoProviderData,
    UnableToFindMerchantRefInUserMerchants,
    UnableToStartApp
} from "common/helpers/errors";

import {
    SET_MERCHANT_REF,
    SET_BU_AND_MERCHANT_REF,
    SET_MERCHANT_CONFIG,
    SET_NORMALIZING_CURRENCY,
    FETCH_MAPPINGS_IF_MISSING,
    SET_ACTIVE_USER,
    SET_AVAILABLE_MERCHANTS
} from "common/actions/common";

import {
    GET_USERS_WITH_NO_PERMISSIONS,
    FETCH_USER_PERMISSIONS_ON_MERCHANT,
    FETCH_USER_OPTINS
} from "common/actions/users";

import {
    ACCESS_DENIED,
    ACCESS_GRANTED
} from "common/actions/config";

import {
    GET_USER_MERCHANT_SETTINGS
} from "common/actions/user_merchant_settings";

import { FETCH_TABLE_CONFIGS } from "common/actions/components";

import { tracking } from "common/components/tracking";
import { request } from "common/components/request";
import { pazienHistory } from "common/components/pazienHistory";

import { RESET_AVAILABILITY_STORE } from "common/actions/dataAvailability";

import { UserModel } from "common/features/user/model";
import { Filters } from "common/components/queryBuilder/savedFilters/filters";
import { Entities } from "merchant/collections/entities";

import { faExclamationCircle } from "@fortawesome/pro-light-svg-icons";

const Acknowledge = Backbone.Model.extend({
    url: "/user/acknowledge/"
});

export const ActiveUser = UserModel.extend({
    url: users.me,
    initialize() {
        // Need to have a model that never changes ID,
        // but allows to pass new data to the source to be saved there
        this.activeMerchant = this.constructor.ActiveMerchantClass.makeProxy();
        this.setPrerequisites();
    },
    
    setPrerequisites() {
        const userPrerequisites = [
            ["entities", this.initEntities], // Entities that user has access to
            ["userData", this.fetchUserData], // User info: name, role, etc.
            ["mappings", FETCH_MAPPINGS_IF_MISSING], // Zoolander mappings contain ref->alias info for common actors like reason_code
            ["acknowledgements", this.fetchUserAcks] // User acknowledgements (did you know things)
        ];
    
        store.dispatch({
            type: "SET_FETCHED_PREREQUISITES",
            payload: "fetching"
        });
        
        this.fetchPrerequisites = Promise.map(userPrerequisites, (prop) => prop[1].call(this))
            .then(() => this.setActiveMerchant(store.getState().common.merchant_ref))
            .then(this.setPermissionsForActiveMerchant.bind(this))
            .then(this.setFiltersForActiveMerchant.bind(this))
            .then(this.getTxnsTableConfigs)
            .then(this.setUserMerchantSettings.bind(this))
            .then(this.checkNeedyUsers.bind(this))
            .then((data) => {
                store.dispatch({
                    type: "SET_FETCHED_PREREQUISITES",
                    payload: "fetched"
                });
                
                return data;
            })
            .catch((error_) => {
                let error = error_;
                if (error_ instanceof NoViewPrivileges) {
                // Capture this error in Sentry (nor now)
                    captureMessage("No view permissions for logged in user", {
                        level: "warning"
                    });
                    emitter.emit("noViewPrivileges", { err: error_ });
                } else if (error_ instanceof NoProviderData) {
                    showError(error);
                } else {
                    error = new UnableToStartApp({
                        header: "Unable to start application",
                        message: "Please refresh the page, as data could not load.",
                        originalError: error_,
                        custom: true,
                        customActions: [{
                            label: "Refresh page",
                            onClick() {
                                window.location.reload(true);
                            }
                        }]
                    });
                    showError(error);
                }
            
                // Throw the error down the promise chain to be picked up later in react-router.
                throw error;
            });
    },
    
    initEntities() {
        this.entities = new Entities();
        this.entities.url = user.merchants;
        
        return this._fetchEntities();
    },
    
    hasMultipleMerchants() {
        return this.entities.length > 1;
    },
    
    _fetchEntities() {
        return retry(() => this.entities.fetch()).then((merchants) => {
            SET_AVAILABLE_MERCHANTS(merchants);
            
            if (merchants === null || !merchants.length) {
                throw new UserIsNotAssigned({
                    message: "Your user is not assigned to a merchant",
                    extra: {
                        ...store.getState().common.user
                    }
                });
            }
        }).catch((error) => {
            // noop here. this error will be picked up by a merchant picker
        });
    },
    
    checkNeedyUsers() {
        // Return earlier if doesn't have to change for needy users
        if (!store.getState().permissions.user_permissions.has_users_needing_permissions_data) return;
        
        // Do not return a promise here. This way the request will not block rendering of the app.
        GET_USERS_WITH_NO_PERMISSIONS().then((data) => {
            const numNeedyUsers = data.length;
            
            // We only display toasts to admins
            if (!store.getState().common.user.admin) return;
    
            if (numNeedyUsers === 1) {
                toast.error(<ToastWithActions
                    message="There is one user who needs permissions assigned."
                    wrapInToastIconDiv
                    iconProps={{
                        icon: faExclamationCircle,
                        size: "lg"
                    }}
                    actions={[{
                        buttonText: "View user",
                        action: () => pazienHistory.navigateWithParams(`preferences/users/users/${data[0]}`, { trigger: true })
                    }
                    ]}
                />, { toastId: "toastNeedyUsers" });
            } else if (numNeedyUsers > 1) {
                toast.error(<ToastWithActions
                    message={`There are ${numNeedyUsers} users who need permissions assigned.`}
                    wrapInToastIconDiv
                    iconProps={{
                        icon: faExclamationCircle,
                        size: "lg"
                    }}
                    actions={[{
                        buttonText: "View users",
                        action: () => pazienHistory.navigateWithParams("preferences/users/users", { trigger: true, extraParams: { needy: 1 } })
                    }
                    ]}
                />, { toastId: "toastNeedyUsers" });
            }
        }).catch((error) => {
            captureException(error);
        });
    },
    
    displayMerchantPicker({ deniedAccessStatusCode = 0 } = {}) {
        return new Promise((resolve, reject) => {
            const state = store.getState();
            
            if (state.common.all_merchants.length === 0) {
                throw new Error("No top level merchants exist for the user");
            } else if (state.common.user.superuser && pazienHistory.isAdminApp()) {
                resolve([state.config.widgets_ref]);
                return;
            }
    
            if (deniedAccessStatusCode === 0) {
                ACCESS_GRANTED({
                    code: deniedAccessStatusCode
                });
            } else {
                ACCESS_DENIED({
                    code: deniedAccessStatusCode
                });
            }

            // If user has access only to one top-level merchant then pick it
            if (state.common.all_merchants.length === 1) {
                resolve([state.common.all_merchants[0].id]);
                return;
            }
    
            // If there are more than one top level merchant then ask the user to pick one
            // eslint-disable-next-line no-promise-executor-return
            return Radio.channel("login").request("merchant:switch", {
                fullPage: true,
                success: resolve,
                error: reject
            });
        }).then(([id, close]) => this.setActiveMerchant(id).then(() => typeof close === "function" && close())).then(() => {
            if (deniedAccessStatusCode !== 0) {
                pazienHistory.navigateWithParams(store.getState().user_merchant_config.start_page, {
                    trigger: true,
                    replace: true,
                    extraParams: {
                        reload: uuid() // We need to pass extra parameter here to generate new fragment, otherwise backbone router will not fire a callback
                    }
                });
            }
        });
    },
    
    setActiveMerchant(matchedEntity) {
        // Reset data availability
        RESET_AVAILABILITY_STORE();
        
        if (!matchedEntity) {
            // If we have no matched entity, then display a merchant picker,
            // asking a user to select a merchant and run setActiveMerchant again
            return this.displayMerchantPicker();
        }
        
        // Here we can translate short merchant_alias to a full merchant_ref
        if (matchedEntity.length < 24) {
            const match = store.getState().common.all_merchants.find((merchant) => merchant.alias === matchedEntity);
            if (match) {
                matchedEntity = match.id;
            } else {
                // Show merchant picker
                return this.displayMerchantPicker();
            }
        }
        
        return new Promise((resolve, reject) => {
            // We need to check if a user has access to requested matchedEntity.
            // The easiest way is to call settings endpoint and verify the response.
            this.requestId = uuid();
            const fetchId = this.requestId;
        
            request(`/merchant/${matchedEntity}/configuration/settings/`).then((data) => {
                // Return earlier if the response is not longer needed
                if (this.requestId !== fetchId) return;
    
                // Backwards compatible with bu_ref as merchant_ref:
                if (data.root_merchant) {
                    store.dispatch(SET_BU_AND_MERCHANT_REF({
                        merchant_ref: data.root_merchant._id,
                        bu_ref: data._id
                    }));
                } else {
                    store.dispatch(SET_MERCHANT_REF(data._id, false));
                }
            
                const activeMerchant = new this.constructor.ActiveMerchantClass({
                    id: matchedEntity,
                    ...data
                });
            
                // The UI doesn't distinguish between BU and root level merchant.
                // The API will provide `root_merchant` property to indicate if the requested `matchedEntity` has a root merchant with structure
                const root_merchant = activeMerchant.getRootMerchantSettings();
                this.updateAvailableEntitesTree(root_merchant._id, root_merchant.business_units);
                
                // Now validate provided bu_ref
                if (store.getState().common.bu_ref && typeof this.entities.findNode(store.getState().common.bu_ref) === "undefined") {
                    store.dispatch(SET_MERCHANT_REF(data._id));
                }
            
                SET_MERCHANT_CONFIG({
                    config: data.root_merchant || data
                });
            
                // Use default currency
                store.dispatch(SET_NORMALIZING_CURRENCY({
                    currency: root_merchant.default_currency,
                    currency_source: "merchant-default"
                }));
            
                tracking.addEventProperties({
                    merchant_id: root_merchant._id,
                    merchant_name: root_merchant.display_name
                });
            
                setTagsContext({
                    merchant_id: root_merchant._id,
                    merchant: root_merchant.display_name
                });
                
                const fetchActiveMerchantDimensions = this.activeMerchant.setMerchantDimensions();
                this.activeMerchant.link(activeMerchant);
                
                // TODO: this is promise spaghetti. resolve
                resolve(fetchActiveMerchantDimensions);
            }).catch((error) => {
                // We found match, but user has no access to the matched entity.
                // Present a merchant picker with an alert
                resolve(this.displayMerchantPicker({
                    deniedAccessStatusCode: error.status,
                    requestedMerchantId: matchedEntity
                }));
            });
        });
    },
    
    cleanUp() {
        this.stopListening();
        
        // Cancel dimensions fetching on clean up to avoid retries
        if (this.activeMerchant.dimensions) {
            this.activeMerchant.dimensions.cancel();
        }
        
        this.activeMerchant.off();
        this.activeMerchant = null;
        
        if (this.entities) {
            this.entities.off();
        }
        
        this.entities = null;
    },
    
    setFiltersForActiveMerchant() {
        this.filters = new Filters();
        
        // Do not throw error. The app can work without saved filters
        return this.filters.fetch().catch(() => []);
    },
    
    setPermissionsForActiveMerchant() {
        return FETCH_USER_PERMISSIONS_ON_MERCHANT()
            .catch((error) => {
                if (error.response?.parsed?.title === "No provider data") {
                    throw new NoProviderData();
                }
                throw error;
            })
            .then((data) => {
                if (store.getState().permissions.user_permissions.canLoadApp === false) {
                    throw new NoViewPrivileges({
                        message: "No view permissions for logged in user. Contact your account administrator"
                    });
                }
                
                return data;
            });
    },
    
    setUserMerchantSettings() {
        if (store.getState().permissions.user_permissions.feature_fee_reports) {
            store.dispatch(FETCH_USER_OPTINS());
        }
        
        return store.dispatch(GET_USER_MERCHANT_SETTINGS());
    },
    
    fetchUserData() {
        // Get instance specific to current user on active merchant
        return retry(() => this.fetch()).then(() => {
            const userObject = this.toJSON();
            emitter.emit("tracking.identify", userObject);
    
            SET_ACTIVE_USER(userObject);
            setUserContext();
        }).catch((error) => {
            captureException(error);
    
            throw new UnableFetchUserData({
                message: "Error fetching user info",
                originalError: error
            });
        });
    },
    
    fetchUserAcks() {
        this.acknowledgements = new Acknowledge({
            id: "acks"
        });
        
        return this.acknowledgements.fetch();
    },
    
    /**
     * Get currently selected node and full tree where the node is located
     * @returns {{selectedNode, selectedTree: *}}
     */
    getSelectedNodeWithTree() {
        // Go through all entities that the user has access to, and find tree of selected entity
        const activeMerchantRef = store.getState().common.bu_ref || store.getState().common.merchant_ref;
        const selectedTree = this.entities.findNode(store.getState().common.bu_ref || store.getState().common.merchant_ref);
        
        const selectedNodeWithTree = this.entities.getChildNodeWithItsTree(activeMerchantRef, { includeParent: true });
        
        if (selectedTree && selectedNodeWithTree && selectedNodeWithTree.at(0)) {
            return {
                selectedTree,
                selectedNode: selectedNodeWithTree.at(0)
            };
        }
        
        throw new UnableToFindMerchantRefInUserMerchants({
            message: "Cannot find a ref in user's merchants/BUs",
            extra: {
                available: this.entities.toJSON(),
                selected: activeMerchantRef
            }
        });
    },
    
    // This method will take business units that came with a merchant info and then insert them in the entities tree
    updateAvailableEntitesTree(id, business_units) {
        // Find the parent node in the list of available entities and insert business units
        if (business_units.length) {
            this.entities.addChildren(id, business_units);
        }
    },

    getTxnsTableConfigs() {
        return FETCH_TABLE_CONFIGS();
    }
}, {
    ActiveMerchantClass: MerchantModel
});
